import { env } from '@/env';
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// NOTE: firebaseConfig は環境変数から取得するようにした
const firebaseConfig = env.VITE_FIREBASE_CONFIG;
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
// export const analytics = getAnalytics(app);
const ENVIRONMENT = env.VITE_ENVIRONMENT;
if (ENVIRONMENT === 'local') connectAuthEmulator(auth, 'http://localhost:9099');
